import gForm from "@/components/g-form/g-form.vue";
import gButton from "@/components/g-button/g-button.vue";
import { useVuelidate } from "@vuelidate/core";
import { required, requiredIf, helpers} from "@vuelidate/validators";
import OrcamentoController from "@/shared/controllers/orcamento/orcamentoController";
import OrcamentoSequenciaController from "@/shared/controllers/orcamentoSequencia/orcamentoSequenciaController";
import ProdutoController from "@/shared/controllers/produto/produtoController";

const name = "CaracProduto";
export default {
  name,

  components: {
    "g-form": gForm,
    "g-button": gButton,
  },

  props: {},

  mounted() {
    OrcamentoController.VerificaSeOrcamentoTemQuantidade(this.$route.params.id).requisicao
    .then((response) => {
      if(response.data.data == false){
        this.$toast.add({severity:'error', detail:'Erro ao Salvar Quantidade. Por favor tente novamente.', life: 5000})
        this.$router.push(`/produto-novo/${this.$route.params.id}/info-basicas`)
      }
    })
    /* this.getInformacoesLoteFrete(); */
    this.getLoteSequencia();
    this.getReorcamento();
    this.getCaracteristicasProduto();
    this.getOrcamentoSequencia();
    this.ImagemEmpresa()


    this.TiposOrcamentoArray = OrcamentoSequenciaController.GetTiposOrcamento().TiposOrcamentoArray;
    this.ProdutoArray = ProdutoController.GetProdutoByOrcamentoClienteEmpresa(this.$route.params.id).ProdutoArray
  },

  setup() {
    return {
      v$: useVuelidate(),
    };
  },

  updated() {},

  data() {
    return {
      status: 0,
      popupCancelaOrc: false,
      imagemEmpresa: '',
      Colunas: [
        {field: 'tipo', header: 'Tipo'},
        {field: 'produto', header: 'Produto'},
      ],
      InformacaoProdutosSequencia: [],
      produtoId: null,
      ProdutoArray: [],
      TipoOrcamentoEnum: null,
      TiposOrcamentoArray: [],
      comprimentoPalete: '',
      larguraPalete: '',
      alturaPalete: '',
      melhorAproveitamento: false,
      observacaoPalete: '',
      copiaOrcamentoQuantidade: false,
      reorcamento: false,
      optionsgerais: [],
      optionscriticas: [],
      optionsespecifica: [],
      opcaooutros: false,
      opcaopalete: false,
      opcaocaixacoletiva: false,
      opcaofilmeencolhivel: false,
      popup: false,
      inputoutros: false,
      inputdeoutros: null,
      criticasavaliadas: false,
      produtoselado: false,
      expostotemperatura: false,
      fechamentomaquina: false,
      contatoalimento: false,
      solvente: false,
      embalagemEspecificaFilmeEncolhivel: false,
      embalagemEspecificaCaixaColetiva: false,
      embalagemEspecificaPalete: false,
      outros: false,
      critica1: false,
      critica2: false,
      critica3: null,
      critica4: null,
      critica5: false,
      amostra: false,
      amostraEspecificacaoTecnica: false,
      fsc: false,
      descricao: "",
      descricaoespc: "",
      legislacao: false,
      /*variaveis referentes a parte de lote frete*/
      opcaoSelecionadaLoteSequencia: "",
      observacaoLoteSequencia: "",
      textoLoteSequencia: "Lote",
      temLoteText: "",
      temLote: false,
      sequenciaValue: false,
      loteDescricao: "",
      sequenciaDescricao: "",
      desabilitaLoteSequencia: false,
      caracteristicasProduto: {},
      embalagemOutros: null,
      observacao: null,
      sugestaoLotes: null,
      habilitarcampo: false,
      escritobotao: true,
      checkAmostra: null,
      amostraTecnica:null,
      AbrirPopupPadrao: false,
      CodigoOrcamento: '',
      papelSeda: false,
      medidaPapelSeda: '',
      medidaPapelSeda2: ''
    };
  },

  validations() {
    //falta adicionar as validações aqui como em lote frete
    //ex:
    let sequenciaDescricaoValidation;
    let loteDescricaoValidation;
    let outrosDescricaoValidation;
    let temSequencia = this.sequenciaValue;
    let temOutrosDescricao = this.embalagemOutros;



    if (temOutrosDescricao && this.AbrirPopupPadrao) {
      outrosDescricaoValidation = {
        required: helpers.withMessage(
          "O campo Descrição Outros é obrigatório",
          required
        ),
      };
    } else {
      outrosDescricaoValidation = {};
    }

    if (this.temLote && this.AbrirPopupPadrao) {
      loteDescricaoValidation = {
        required: helpers.withMessage(
          "O campo Descrição Lote é obrigatório",
          required
        ),
      };
    } else {
      loteDescricaoValidation = {};
    }
    if (temSequencia && this.AbrirPopupPadrao) {
      sequenciaDescricaoValidation = {
        required: helpers.withMessage(
          "O campo Descrição de Sequência é obrigatório",
          required
        ),
      };
    } else {
      sequenciaDescricaoValidation = {};
    }


    if (!this.temLote && !temSequencia) {
      loteDescricaoValidation = {};
      sequenciaDescricaoValidation = {};
    }

    let validaCamposPalete = this.embalagemEspecificaPalete && !this.melhorAproveitamento && !this.reorcamento && !this.copiaOrcamentoQuantidade
    let alturaPaleteValidation = {require: helpers.withMessage('o campo altura para Palete é obrigatório', requiredIf(validaCamposPalete && this.AbrirPopupPadrao))};
    let larguraPaleteValidation = {require: helpers.withMessage('o campo largura para Palete é obrigatório', requiredIf(validaCamposPalete && this.AbrirPopupPadrao))};
    let comprimentoPaleteValidation = {require: helpers.withMessage('o campo comprimento para Palete é obrigatório', requiredIf(validaCamposPalete && this.AbrirPopupPadrao))};
    let validaCampoPapelSeda = this.papelSeda
    let medidaPapelSeda = {require: helpers.withMessage('o campo medida do papel de seda é obrigatório', requiredIf(validaCampoPapelSeda))};
    let medidaPapelSeda2 = {require: helpers.withMessage('o campo medida do papel de seda é obrigatório', requiredIf(validaCampoPapelSeda))};


    return {
      sequenciaDescricao: sequenciaDescricaoValidation,
      loteDescricao: loteDescricaoValidation,
      descricao: outrosDescricaoValidation,
      critica3: {require: helpers.withMessage("O campo de Fechamento por Máquina precisa ser preenchido", required)},
      alturaPalete: alturaPaleteValidation,
      larguraPalete: larguraPaleteValidation,
      comprimentoPalete: comprimentoPaleteValidation,
      medidaPapelSeda: medidaPapelSeda,
      medidaPapelSeda2: medidaPapelSeda2
    };
  },

  methods: {
    cancelaOrcamento() {
      this.$isLoading(true)
      OrcamentoController.DeleteOrcamento(this.$route.params.id).requisicao
      .then(() =>
        this.popupCancelaOrc = false,
        this.$toast.add({severity:'success', detail:'Orçamento Excluido com Sucesso!', life: 5000}),
        setTimeout(() => {
          this.$isLoading(false),
          this.$router.push('/produto-novo-inicio');
        },2000))
    },
    fechaPopupCancelar() {
      this.popupCancelaOrc = false;
    },
    abrePopupCancelarOrcamento(){
      this.popupCancelaOrc = true;
    },
    ImagemEmpresa(){
      OrcamentoController.GetNomeEmpresaByOrcamentoId(this.$route.params.id).requisicao
      .then((response) => {
        this.NomeEmpresa=response.data.message

        const nomeEmpresa = () => {
          if(this.NomeEmpresa.includes('SUPREMA')) return 'SUPREMA';
          if(this.NomeEmpresa.includes('NORDESTE')) return 'NORDESTE';
          return 'JAUENSE'
        }

        const urlBase = window.location.host
        this.imagemEmpresa =  `//${urlBase}/repositorio/${nomeEmpresa()}/LOGOTIPO.png`;
      })
    },
    LimparProduto(){
      if(this.TipoOrcamentoEnum == 0)
      {
        this.produtoId = null
      }
    },
    excluir(data) {
      let dataEmString = JSON.stringify(data)
      this.InformacaoProdutosSequencia = this.InformacaoProdutosSequencia.filter(e => JSON.stringify(e) != dataEmString)
    },

    adicionarProdutoAoGrid(){
      if(this.TipoOrcamentoEnum == null && this.produtoId == null)
      {
        this.$toast.add({ severity: 'error', summary: 'Selecione um Tipo e um Produto', detail: 'Tipo e Produto Obrigatórios', life: 4000 });
        return
      }
      if(this.TipoOrcamentoEnum == null && this.produtoId != null)
      {
        this.$toast.add({ severity: 'error', summary: 'Selecione um Tipo e um Produto Também', detail: 'Tipo e Produto Obrigatórios', life: 4000 });
        return
      }
      if((this.TipoOrcamentoEnum == 1 && this.produtoId == null) || (this.TipoOrcamentoEnum == 2 && this.produtoId == null) )
      {
        this.$toast.add({ severity: 'error', summary: 'Produto Obrigatório', detail: 'Selecione um produto', life: 4000 });
        return
      }

      if(this.TipoOrcamentoEnum != 0)
      {
        let Produto = this.ProdutoArray.find((Element) => Element.produtoId == this.produtoId)
        let TipoText = this.TiposOrcamentoArray.find((Element) => Element.enum == this.TipoOrcamentoEnum)

        let variavel =
          {"produtoId": this.produtoId, "tipoEnum": this.TipoOrcamentoEnum, "tipo":TipoText.text, "produto": Produto.nomeProduto }
          this.InformacaoProdutosSequencia.push(variavel)

        return
      }

      if(this.TipoOrcamentoEnum == 0)
      {
        let TipoText = this.TiposOrcamentoArray.find((Element) => Element.enum == this.TipoOrcamentoEnum)
        let variavel =
          {"produtoId":null, "tipoEnum": this.TipoOrcamentoEnum, "tipo": TipoText.text, "produto": null }


          this.InformacaoProdutosSequencia.push(variavel)

        return
      }


    },

    popularCaracteristicaProduto() {
      this.caracteristicasProduto =
        OrcamentoController.GetCaracteristicasProduto(
          this.$route.params.id
        ).CaracteristicasProduto;
    },


    removerNaoDigitos(textoOriginal){
        if(!textoOriginal) return null;
        textoOriginal = textoOriginal.toString();
        return textoOriginal.replaceAll(/\D/gm, '');
    },

    nullaDesc() {
      this.descricao = null;
      this.descricaoespec = null;
    },

    finalizar() {
      if (this.sequenciaValue) {
        if(this.InformacaoProdutosSequencia.length < 2 && this.AbrirPopupPadrao == true)
        {
          this.$toast.add({ severity: 'error', summary: 'Selecione no mínimo 2 produtos da Sequência', detail: 'Selecione no mínimo 2 produtos da Sequência', life: 4000 });
          return
          }
        }
          this.validateCriticas();
    },

    validateCriticas() {
      if (this.v$.$invalid === true) {
        this.v$.$silentErrors.forEach((error) => {
          this.$toast.add({
            severity: "error",
            summary: "ERRO",
            detail: error.$message,
            life: 5000,
          });
          return;
        });
      } else {
        this.salvarOrcamentoCaracteristicas();
      }
    },

    salvarOrcamentoCaracteristicas() {
      this.escritobotao = false
      
      let OrcamentoCaracteristicasArray = {
        FSC: this.fsc,
        Tipo: this.tipoSelecionado,
        Legislacao: this.legislacao,
        Critica1: this.critica1,
        Critica2: this.critica2,
        Critica3: this.critica3,
        Critica5: this.critica5,
        EmbalagemOutros: this.embalagemOutros,
        DescricaoOutrasEmbalagens: this.embalagemOutros ? this.descricao : "",
        DescricaoOutrasEmbalagensEspecificas: this.descricaoespec,
        Observacao: this.observacao,
        EmbalagemEspecificaFilmeEncolhivel:this.embalagemEspecificaFilmeEncolhivel,
        EmbalagemEspecificaCaixaColetiva: this.embalagemEspecificaCaixaColetiva,
        EmbalagemEspecificaPalete: this.embalagemEspecificaPalete,
        Lote: this.loteDescricao != "" ? this.loteDescricao : null,
        DescricaoSequencia: this.sequenciaDescricao != "" ? this.sequenciaDescricao : null,
        ComprimentoPalete: this.removerNaoDigitos(this.comprimentoPalete),
        AlturaPalete: this.removerNaoDigitos(this.alturaPalete),
        LarguraPalete: this.removerNaoDigitos(this.larguraPalete),
        MelhorAproveitamento: this.melhorAproveitamento,
        ObservacaoPalete: this.observacaoPalete,
        PapelSeda: this.papelSeda,
        MedidaPapelSeda: this.medidaPapelSeda,
        MedidaPapelSeda2: this.medidaPapelSeda2,
        ReOrcamento: this.reorcamento
      };
      this.axios({
        method: "post",
        url:
          process.env.VUE_APP_WEB_API +
          `Orcamento/postCaracteristicas/${this.$route.params.id}`,
        data: OrcamentoCaracteristicasArray,
      })
        .then(() => {
            //O envio ao CRM ocorre no caminho de sucesso de SalvarOrcamentoSequencia
            //(MandarOrcamentoCRM). Aqui a chamada rodava em paralelo, entao o orcamento ia
            //para o CRM mesmo quando a gravacao da sequencia falhava - e em duplicidade,
            //porque as duas chamam o mesmo endpoint.
            if (this.sequenciaValue) {
              this.SalvarOrcamentoSequencia()
              return
            }
            // Sem sequencia nao ha o que gravar em OrcamentoSequencia: seguir direto
            // para o numero do orcamento e o envio ao CRM, senao uma falha no endpoint
            // de sequencia impediria a integracao de um orcamento que nao tem sequencia.
            this.GetCodigoOrcamento()
            setTimeout(() => {
              this.MandarOrcamentoCRM()
            }, 3000)
        })
        .catch((err) =>  err);
    },
    SalvarOrcamentoSequencia(){
      this.$refs.botaoContinuar.isBusy()
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + 'OrcamentoSequencia/PostOrcamentoSequencia',
        data: {
          InformacaoProdutosSequencia: this.InformacaoProdutosSequencia,
          orcamentoId: this.$route.params.id,
        }
      })
        .then((response) => {
          if (response.data && response.data.code < 0) {
            console.error('Erro ao gravar a sequência do orçamento:', response.data.message);
            this.$toast.add({ severity: 'error', summary: 'Sequência do orçamento', detail: 'Não foi possível gravar a sequência do orçamento. Tente novamente; se o erro continuar, acione o suporte.', life: 8000 });
            this.liberarBotaoFinalizar();
            return;
          }

          this.GetCodigoOrcamento();
          setTimeout(() => {
            this.MandarOrcamentoCRM();
          }, 3000);
        })
        .catch((err) => {
          console.error('Erro ao gravar a sequência do orçamento:', err.message);
          this.$toast.add({ severity: 'error', summary: 'Sequência do orçamento', detail: 'Falha de comunicação ao gravar a sequência do orçamento. Verifique sua conexão e tente novamente.', life: 8000 });
          this.liberarBotaoFinalizar();
        });
    },

    //Devolve o botao FINALIZAR ao estado inicial: o rotulo depende de escritobotao e o
    //clique depende de isBusy. Chamado so nos caminhos de erro - no sucesso o botao
    //permanece travado ate o popup do orcamento, para nao permitir duplo envio.
    liberarBotaoFinalizar(){
      this.escritobotao = true;
      this.$refs.botaoContinuar.isBusy();
    },

    MandarOrcamentoCRM() {
      this.axios({
        method: 'post',
        url: process.env.VUE_APP_WEB_API + `Orcamento/EnviarOrcamentoCRM/${this.$route.params.id}`,
      })
        .then((response) => {
          if (response.data && response.data.code < 0) {
            console.error('Erro ao mandar orçamento para CRM:', response.data.message);
            this.$toast.add({ severity: 'warn', summary: 'Integração CRM', detail: 'O orçamento foi gravado, mas não foi possível integrá-lo ao CRM. Acione o suporte informando o número do orçamento.', life: 8000 });
          }
        })
        .catch((err) => {
          console.error('Erro ao mandar orçamento para CRM:', err.message);
          this.$toast.add({ severity: 'error', summary: 'Integração CRM', detail: 'O orçamento foi gravado, mas houve falha de comunicação com o CRM. Acione o suporte informando o número do orçamento.', life: 8000 });
        });
    },

    GetCodigoOrcamento(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Orcamento/GetCodigoOrcamento/${this.$route.params.id}`,
      })
        .then((response) => {
          this.CodigoOrcamento = response.data.message
          this.popup=true

          if(this.copiaOrcamentoQuantidade == true)
            {
              this.AbrirPopupPadrao=false
              return
            }

            if(this.reorcamento == true)
              {
                this.AbrirPopupPadrao=false
                return
              }
              if(this.status == 16)
                {
                  this.AbrirPopupPadrao=false
                  return
                }
          this.AbrirPopupPadrao=true
          //this.popup=true
        })
        .catch(() => {
        });
    },

    voltarstep4() {
      if (this.checkAmostra == true || this.amostraTecnica == true)
      {
        this.$router.push(`/produto-novo/${this.$route.params.id}/info-basicas`)
      } else {
        this.$router.push(`/produto-novo/${this.$route.params.id}/componentes-produto`)
      }
    },

    fechapopup() {
      this.popup = false;
      this.insertOrcamentoVariacao();
    },

    paginafinalizada() {
      this.$router.push(`/orcamento-final/${this.$route.params.id}`);
    },

    aplicarCentimetro(valor){
      if(!this[valor]) return;
      this[valor] += ' cm'
    },

    camponumero ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        $event.preventDefault();
      }
    },

    getInformacoesLoteFrete() {
      this.axios({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API +
          `LoteFrete/GetLoteFreteFinalByOrcamentoId/${this.$route.params.id}`,
      })
        .then((response) => {
          let sequencia = response.data.data.sequencia;
          this.opcaoSelecionadaLoteSequencia = sequencia
            ? response.data.data.getSequencia
            : response.data.data.indicadorEnum;
          this.textoLoteSequencia = sequencia ? "Sequência" : "Lote";
        })
        .catch(() => {});
    },
    getLoteSequencia() {
      this.$isLoading(true)
      this.axios({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API +
          `Orcamento/GetLoteSequenciaByOrcamentoId/${this.$route.params.id}`,
      }).then((response) => {
        this.loteInfoText = response.data.data.informacaoLoteText;
        this.sequenciaValue = response.data.data.sequencia;
        if (this.loteInfoText === "Não") {
          this.temLote = false;
        } else {
          this.temLote = true;
          //this.sequenciaValue = false
        }
      }).finally(()=> {
        this.$isLoading(false)
      })
      
    },

    getCaracteristicasProduto(){
      OrcamentoController.GetCaracteristicasProduto(this.$route.params.id).requisicao
      .then(res => {
        this.status = res.data.data.status;
        this.amostra = res.data.data.amostra;
        this.amostraEspecificacaoTecnica = res.data.data.amostraEspecificacaoTecnica;
        this.fsc = res.data.data.fsc;
        this.tipoSelecionado = res.data.data.tipo;
        this.legislacao = res.data.data.legislacao;
        this.critica1 = res.data.data.critica1;
        this.critica2 = res.data.data.critica2;
        this.critica3 = res.data.data.critica3;
        this.critica4 = res.data.data.critica4;
        this.critica5 = res.data.data.critica5;
        this.embalagemOutros = res.data.data.embalagemOutros;
        this.descricao = res.data.data.descricaoOutrasEmbalagens;
        this.descricaoespec =
          res.data.data.descricaoOutrasEmbalagensEspecificas;
        this.observacao = res.data.data.observacao;
        this.embalagemEspecificaFilmeEncolhivel =
          res.data.data.embalagemEspecificaFilmeEncolhivel;
        this.embalagemEspecificaCaixaColetiva =
          res.data.data.embalagemEspecificaCaixaColetiva;
        this.embalagemEspecificaPalete =
          res.data.data.embalagemEspecificaPalete;
        this.loteDescricao = res.data.data.lote;
        this.sequenciaDescricao = res.data.data.descricaoSequencia;
        this.melhorAproveitamento = res.data.data.melhorAproveitamento;
        this.observacaoPalete = res.data.data.observacaoPalete;
        this.comprimentoPalete = res.data.data.comprimentoPalete;
        this.alturaPalete = res.data.data.alturaPalete;
        this.papelSeda = res.data.data.papelSeda;
        this.medidaPapelSeda = res.data.data.medidaPapelSeda;
        this.medidaPapelSeda2 = res.data.data.medidaPapelSeda2
      });
    },

    getOrcamentoSequencia(){
      OrcamentoSequenciaController.GetOrcamentoSequenciaByOrcamentoId(this.$route.params.id).requisicao
      .then(res => {
        this.InformacaoProdutosSequencia = res.data.data.informacaoProdutosSequencia
        if(this.InformacaoProdutosSequencia.length > 0){
          this.AbrirPopupPadrao = true
        }
      });
    },


    insertOrcamentoVariacao() {
      this.axios({
        method: "post",
        url:
          process.env.VUE_APP_WEB_API +
          `Orcamento/InsertOrReplaceOrcaProdRepet/${this.$route.params.id}`,
        data: {},
      })
        .then((response) => {
          this.OrcamentoId = response.data.data;
          if (!response.data) {
            this.$toast.add({
              severity: "error",
              summary: "Erro",
              detail: "Nao foi possivel criar a copia do orcamento",
              life: 5000,
            });
            return;
          }
          if (!this.OrcamentoId) {
            this.$toast.add({
              severity: "error",
              summary: "Erro",
              detail: "Nao foi possivel criar a copia do orcamento",
              life: 5000,
            });
            return;
          }
          this.$router.push(`/produto-novo/${response.data.data}/lote-frete`);
        })
        .catch(() => {});
    },

    desabilitaCriticas() {
      if (this.critica1 === true) {
        (this.critica2 = false),
          (this.critica3 = false),
          (this.critica4 = false),
          (this.critica5 = false);
      }
    },

    getReorcamento() {
      this.axios({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API +
          `Orcamento/GetInfosBasicasProdutoNovo/${this.$route.params.id}`,
      })
        .then((Response) => {
          this.reorcamento = Response.data.data.reorcamento;
          this.copiaOrcamentoQuantidade = Response.data.data.copiaOrcamentoQuantidade;
          this.checkAmostra = Response.data.data.amostra
          this.amostraTecnica = Response.data.data.amostraEspecificacaoTecnica

          if( this.copiaOrcamentoQuantidade==false && this.reorcamento==false )
          {
            this.AbrirPopupPadrao = true
          }

          if( this.copiaOrcamentoQuantidade==null && this.reorcamento==null )
          {
            this.AbrirPopupPadrao = true
          }

          if( this.copiaOrcamentoQuantidade==null && this.reorcamento==false )
          {
            this.AbrirPopupPadrao = true
          }

          if( this.copiaOrcamentoQuantidade==false && this.reorcamento==null )
          {
            this.AbrirPopupPadrao = true
          }
          
        })
        .catch(() => {});
    },
  },

  computed: { },

  watch: {
    melhorAproveitamento(novoValor){
      if(novoValor){
        this.alturaPalete = ''
        this.comprimentoPalete = ''
      }
    },
  }
};
